{
  "actionbar.actions": "Aktionen",
  "actionbar.actionsAvailable": "Aktionen verfügbar.",
  "actionbar.clearSelection": "Auswahl löschen",
  "actionbar.selected": "{count, plural, =0 {Nichts ausgewählt} one {# ausgewählt} other {# ausgewählt}}",
  "actionbar.selectedAll": "Alles ausgewählt",
  "breadcrumbs.more": "Weitere Elemente",
  "button.pending": "Ausstehend",
  "calendar.invalidSelection": "Ausgewählte(s) {selectedCount, plural, one {Datum} other {Daten}} nicht verfügbar.",
  "combobox.noResults": "Keine Ergebnisse",
  "contextualhelp.help": "Hilfe",
  "contextualhelp.info": "Informationen",
  "datepicker.endTime": "Endzeit",
  "datepicker.startTime": "Startzeit",
  "datepicker.time": "Uhrzeit",
  "dialog.alert": "Warnhinweis",
  "dialog.dismiss": "Schließen",
  "dropzone.replaceMessage": "Datei zum Ersetzen ablegen",
  "inlinealert.informative": "Informationen",
  "inlinealert.negative": "Fehler",
  "inlinealert.notice": "Warnung",
  "inlinealert.positive": "Erfolg",
  "label.(optional)": "(optional)",
  "label.(required)": "(erforderlich)",
  "menu.moreActions": "Mehr Aktionen",
  "menu.unavailable": "Nicht verfügbar, für Details erweitern",
  "notificationbadge.indicatorOnly": "Neue Aktivität",
  "notificationbadge.plus": "{notifications}+",
  "picker.placeholder": "Auswählen…",
  "picker.selectedCount": "{count, plural, =0 {Keine Elemente ausgewählt} one {# Element ausgewählt} other {# Elemente ausgewählt}}",
  "slider.maximum": "Maximum",
  "slider.minimum": "Minimum",
  "table.cancel": "Abbrechen",
  "table.drag": "Ziehen",
  "table.editCell": "Zelle bearbeiten",
  "table.loading": "Laden...",
  "table.loadingMore": "Mehr laden ...",
  "table.resizeColumn": "Spaltengröße ändern",
  "table.save": "Speichern",
  "table.sortAscending": "Aufsteigend sortieren",
  "table.sortDescending": "Absteigend sortieren",
  "tag.actions": "Aktionen",
  "tag.hideButtonLabel": "Weniger zeigen",
  "tag.noTags": "Keine",
  "tag.showAllButtonLabel": "Alle anzeigen ({tagCount, number})",
  "toast.clearAll": "Alle löschen",
  "toast.collapse": "Reduzieren",
  "toast.showAll": "Alle anzeigen"
}
